import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { useStoreActions } from '~/store/store-context';
export const useGetUserReferral = ()=>{
    const { api } = useStoreActions();
    const { data, isLoading } = useQueryState({
        queryKey: [
            QueryKeys.UserReferral
        ],
        queryFn: ()=>api.user.referral()
    });
    return {
        referral: data,
        isLoading
    };
};
